module.exports = __webpack_public_path__ + "static/logo-e028f0af67e44601aa4b51649f4b0705.png";